const { detect } = require('detect-browser');
const browser = detect();

let imgTile;

if(browser.name === 'chrome'){
    imgTile = {
        "type": "raster",
        "url": "mapbox://uaeu.1b35p18j",
        "tileSize": 256
    }
}else{
    imgTile = {
        "type": "raster",
        "tiles": [
            "https://api.mapbox.com/v4/uaeu.1b35p18j/{z}/{x}/{y}@2x.png?access_token=pk.eyJ1Ijoibm91cGhhbHBncyIsImEiOiJjajV0YXZxdDIxZmtjMzNwajRjaHo3dzBmIn0.JRJtyy5Epzx6QKmfy5FN7g"
        ],
        "tileSize": 256
    }
}

const mapStyles = {
    "version": 8,
    "name": "uaeu",
    "metadata": {
        "mapbox:autocomposite": true,
        "mapbox:type": "template"
    },
    "center": [
        55.678677781457054,
        24.198490356012897
    ],
    "zoom": 15,
    "bearing": 0,
    "pitch": 0,
    "sources": {
        "composite": {
            "url": "mapbox://mapbox.mapbox-streets-v7",
            "type": "vector"
        },
        "mapbox://uaeu.1b35p18j": imgTile,
        "mapbox://mapbox.satellite": {
            "url": "mapbox://mapbox.satellite",
            "type": "raster",
            "tileSize": 256
        }
    },
    "sprite": "mapbox://sprites/uaeu/cjblt4i8t3i672sp4v6kd1y6s",
    "glyphs": "mapbox://fonts/uaeu/{fontstack}/{range}.pbf",
    "layers": [
        {
            "id": "background",
            "type": "background",
            "paint": {
                "background-color": "#dedede"
            }
        },
        {
            "id": "landuse_overlay_national_park",
            "type": "fill",
            "source": "composite",
            "source-layer": "landuse_overlay",
            "filter": [
                "==",
                "class",
                "national_park"
            ],
            "paint": {
                "fill-color": "#d2edae",
                "fill-opacity": 0.75
            }
        },
        {
            "id": "landuse_park",
            "type": "fill",
            "source": "composite",
            "source-layer": "landuse",
            "filter": [
                "==",
                "class",
                "park"
            ],
            "paint": {
                "fill-color": "#d2edae"
            }
        },
        {
            "id": "waterway",
            "type": "line",
            "source": "composite",
            "source-layer": "waterway",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "in",
                    "class",
                    "canal",
                    "river"
                ]
            ],
            "paint": {
                "line-color": "#a0cfdf",
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [
                            8,
                            0.5
                        ],
                        [
                            20,
                            15
                        ]
                    ]
                }
            }
        },
        {
            "id": "water",
            "type": "fill",
            "source": "composite",
            "source-layer": "water",
            "paint": {
                "fill-color": "#a0cfdf"
            }
        },
        {
            "id": "building",
            "type": "fill",
            "source": "composite",
            "source-layer": "building",
            "paint": {
                "fill-color": "#d6d6d6"
            }
        },
        {
            "id": "tunnel_minor",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "tunnel"
                    ],
                    [
                        "in",
                        "class",
                        "link",
                        "motorway_link",
                        "path",
                        "pedestrian",
                        "service",
                        "street",
                        "street_limited",
                        "track"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#efefef",
                "line-width": {
                    "base": 1.55,
                    "stops": [
                        [
                            4,
                            0.25
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                },
                "line-dasharray": [
                    0.36,
                    0.18
                ]
            }
        },
        {
            "id": "tunnel_major",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "tunnel"
                    ],
                    [
                        "in",
                        "class",
                        "motorway",
                        "primary",
                        "secondary",
                        "tertiary",
                        "trunk"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [
                            6,
                            0.5
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                },
                "line-dasharray": [
                    0.28,
                    0.14
                ]
            }
        },
        {
            "id": "road_minor",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "in",
                        "class",
                        "link",
                        "motorway_link",
                        "path",
                        "pedestrian",
                        "service",
                        "street",
                        "street_limited",
                        "track"
                    ],
                    [
                        "in",
                        "structure",
                        "ford",
                        "none"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#efefef",
                "line-width": {
                    "base": 1.55,
                    "stops": [
                        [
                            4,
                            0.25
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "road_major",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "in",
                        "class",
                        "motorway",
                        "primary",
                        "secondary",
                        "tertiary",
                        "trunk"
                    ],
                    [
                        "in",
                        "structure",
                        "ford",
                        "none"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [
                            6,
                            0.5
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "bridge_minor case",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "bridge"
                    ],
                    [
                        "in",
                        "class",
                        "link",
                        "motorway_link",
                        "path",
                        "pedestrian",
                        "service",
                        "street",
                        "street_limited",
                        "track"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#dedede",
                "line-width": {
                    "base": 1.6,
                    "stops": [
                        [
                            12,
                            0.5
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
                "line-gap-width": {
                    "base": 1.55,
                    "stops": [
                        [
                            4,
                            0.25
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "bridge_major case",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "bridge"
                    ],
                    [
                        "in",
                        "class",
                        "motorway",
                        "primary",
                        "secondary",
                        "tertiary",
                        "trunk"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#dedede",
                "line-width": {
                    "base": 1.6,
                    "stops": [
                        [
                            12,
                            0.5
                        ],
                        [
                            20,
                            10
                        ]
                    ]
                },
                "line-gap-width": {
                    "base": 1.55,
                    "stops": [
                        [
                            4,
                            0.25
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "bridge_minor",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "bridge"
                    ],
                    [
                        "in",
                        "class",
                        "link",
                        "motorway_link",
                        "path",
                        "pedestrian",
                        "service",
                        "street",
                        "street_limited",
                        "track"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#efefef",
                "line-width": {
                    "base": 1.55,
                    "stops": [
                        [
                            4,
                            0.25
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "bridge_major",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "==",
                        "structure",
                        "bridge"
                    ],
                    [
                        "in",
                        "class",
                        "motorway",
                        "primary",
                        "secondary",
                        "tertiary",
                        "trunk"
                    ]
                ]
            ],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [
                            6,
                            0.5
                        ],
                        [
                            20,
                            30
                        ]
                    ]
                }
            }
        },
        {
            "id": "admin_country",
            "type": "line",
            "source": "composite",
            "source-layer": "admin",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "all",
                    [
                        "<=",
                        "admin_level",
                        2
                    ],
                    [
                        "==",
                        "maritime",
                        0
                    ]
                ]
            ],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#8b8a8a",
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [
                            3,
                            0.5
                        ],
                        [
                            22,
                            15
                        ]
                    ]
                }
            }
        },
        {
            "id": "poi_label",
            "type": "symbol",
            "source": "composite",
            "source-layer": "poi_label",
            "minzoom": 5,
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "all",
                    [
                        "==",
                        "localrank",
                        1
                    ],
                    [
                        "==",
                        "scalerank",
                        1
                    ]
                ]
            ],
            "layout": {
                "icon-image": "{maki}-11",
                "text-offset": [
                    0,
                    0.5
                ],
                "text-field": "{name_en}",
                "text-font": [
                    "Open Sans Semibold",
                    "Arial Unicode MS Bold"
                ],
                "text-max-width": 8,
                "text-anchor": "top",
                "text-size": 11,
                "icon-size": 1
            },
            "paint": {
                "text-color": "#666",
                "text-halo-width": 1,
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-blur": 1
            }
        },
        {
            "id": "road_major_label",
            "type": "symbol",
            "source": "composite",
            "source-layer": "road_label",
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "in",
                    "class",
                    "motorway",
                    "primary",
                    "secondary",
                    "tertiary",
                    "trunk"
                ]
            ],
            "layout": {
                "symbol-placement": "line",
                "text-field": "{name_en}",
                "text-font": [
                    "Open Sans Semibold",
                    "Arial Unicode MS Bold"
                ],
                "text-transform": "uppercase",
                "text-letter-spacing": 0.1,
                "text-size": {
                    "base": 1.4,
                    "stops": [
                        [
                            10,
                            8
                        ],
                        [
                            20,
                            14
                        ]
                    ]
                }
            },
            "paint": {
                "text-color": "#666",
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-width": 2
            }
        },
        {
            "id": "place_label_other",
            "type": "symbol",
            "source": "composite",
            "source-layer": "place_label",
            "minzoom": 8,
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "in",
                    "type",
                    "hamlet",
                    "island",
                    "neighbourhood",
                    "suburb",
                    "town",
                    "village"
                ]
            ],
            "layout": {
                "text-field": "{name_en}",
                "text-font": [
                    "Open Sans Semibold",
                    "Arial Unicode MS Bold"
                ],
                "text-max-width": 6,
                "text-size": {
                    "stops": [
                        [
                            6,
                            12
                        ],
                        [
                            12,
                            16
                        ]
                    ]
                }
            },
            "paint": {
                "text-color": "#666",
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-width": 1,
                "text-halo-blur": 1
            }
        },
        {
            "id": "place_label_city",
            "type": "symbol",
            "source": "composite",
            "source-layer": "place_label",
            "maxzoom": 16,
            "filter": [
                "all",
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "==",
                    "type",
                    "city"
                ]
            ],
            "layout": {
                "text-field": "{name_en}",
                "text-font": [
                    "Open Sans Bold",
                    "Arial Unicode MS Bold"
                ],
                "text-max-width": 10,
                "text-size": {
                    "stops": [
                        [
                            3,
                            12
                        ],
                        [
                            8,
                            16
                        ]
                    ]
                }
            },
            "paint": {
                "text-color": "#666",
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-width": 1,
                "text-halo-blur": 1
            }
        },
        {
            "id": "country_label",
            "type": "symbol",
            "source": "composite",
            "source-layer": "country_label",
            "maxzoom": 12,
            "filter": [
                "==",
                "$type",
                "Point"
            ],
            "layout": {
                "text-field": "{name_en}",
                "text-font": [
                    "Open Sans Regular",
                    "Arial Unicode MS Regular"
                ],
                "text-max-width": 10,
                "text-size": {
                    "stops": [
                        [
                            3,
                            14
                        ],
                        [
                            8,
                            22
                        ]
                    ]
                }
            },
            "paint": {
                "text-color": "#666",
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-width": 1,
                "text-halo-blur": 1
            }
        },
        {
            "id": "uaeu-raster",
            "type": "raster",
            "source": "mapbox://mapbox.satellite",
            "layout": {
                "visibility": "none"
            },
            "paint": {}
        },
        {
            "id": "uaeu-vector",
            "type": "raster",
            "source": "mapbox://uaeu.1b35p18j",
            "minzoom": 13.5,
            "layout": {
                "visibility": "visible"
            },
            "paint": {}
        }
    ],
    "created": "2017-12-25T06:13:52.947Z",
    "id": "cjblt4i8t3i672sp4v6kd1y6s",
    "modified": "2017-12-25T07:35:36.196Z",
    "owner": "uaeu",
    "visibility": "private",
    "draft": false
}

export default mapStyles;


// WEBPACK FOOTER //
// ./src/utils/Style.js